import axios from 'axios';

const apiClient = axios.create({
  // Use the env variable you defined in .env
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/v1/admin`,
  headers: {
    'Content-type': 'application/json'
  }
});
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export default apiClient;






// // src\http-common.js

// // import axios from "axios";
// // const token = localStorage.getItem('token');
// // console.log(token);
// // export default axios.create({
// //   baseURL: "http://localhost:8080/api/v1/admin",
// //   headers: {
// //     "Content-type": "application/json",
// //     "Authorization ": token,
// //   }
// // });

// import axios from 'axios';

// // Create an instance of Axios
// const apiClient = axios.create({
//   //baseURL: 'https://media-device-stg-dot-bhmd-dev-app-navya.el.r.appspot.com/api/v1/admin',
//   baseURL: 'https://digitalsignage.digisamhita.com/api/v1/admin',
//   headers: {
//     'Content-type': 'application/json'
//   }
// });

// apiClient.interceptors.request.use(config => {
//   const token = localStorage.getItem('token');
//   if (token) {
//     config.headers['Authorization'] = `Bearer ${token}`;
//   }
//   return config;
// }, error => {
//   return Promise.reject(error);
// });

// export default apiClient;